import React, { Component } from 'react';
import {} from 'carbon-components-react';
import InspectionWeekHeader from './InspectionWeekHeader';
import { InspectionWeekBody } from './InspectionWeekBody';

export class InspectionMonthHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendar: this.props.calendar,
    };
  }

  render() {
    return this.props.calendar.map((formonth) => (
      <>
        <tr className="fist-row-header ">
          {formonth.months.map((month) => (
            
            <th
              colSpan="4"
              className={
                 this.props?.monthsSelected != null ? this.props.monthsSelected.find((el) => el==  month.monthsNumber)?
                'box-information-tilte-description headerSelected' :
                month.selected
                  ? 'box-information-tilte-description headerSelected'
                  : 'box-information-tilte-description' : null
              }
              key={month.monthName}
              onClick={
                this.props?.monthsSelected != null ? this.props?.monthsSelected.find((el) => el==  month.monthsNumber)?
                month.selected = true :    null : null,
                (e) => {
                this.props.onSelectMonth(month);
                month.selected = !month.selected;
              }}
            >
              {month.monthName}
            </th>
          ))}
        </tr>
        <tr className="second-row-header">
          {formonth.weeksList.map((week) => (
            <th
              colSpan="1"
              id={`row_h${week.weekNumber}`}
              key={week.weekNumber}
              onClick={
                this.props?.weeksSelected != null ? this.props?.weeksSelected.find((el) => el==  week.weekNumber)?
                week.selected = true :    null : null,
                (e) => {
                this.props.onSelectWeek(week.weekNumber);
                week.selected = !week.selected;
              }}
            >
              <InspectionWeekHeader
                numberweek={week.weekNumber}
                numberweekstart={week.startWeek}
                numberweekend={week.endWeek}
                selected={week.selected}
              />
            </th>
          ))}
        </tr>
        <tr className="table-row-drill" id={`row_${formonth.weekNumber}`}>
          {formonth.weeksList.map((week) => (
            <td
              colSpan="1"
              id={`row_${week.weekNumber}`}
              key={week.weekNumber}
              onClick={(e) => {
                this.props.onSelectWeek(week.weekNumber);
                week.selected = !week.selected;
              }}
            >
              <InspectionWeekBody
                keyweek={week.weekNumber}
                draft={week.statusDraft}
                approved={week.statusApproved}
                submit={week.statusSubmitted}
                planned={week.statusPlanned}
                isDrill={this.props.isDrill}
              />
            </td>
          ))}
        </tr>
      </>
    ));
  }
}

InspectionMonthHeader.defaultProps = {
  isDrill: false
}
